
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router'
import Status from './Status'
import { color as colors } from 'ui/variables'
import './Tile.css'

const Tile = props => {
  const { rel, tags, logo, target, title, action, subtitle, indicatorStatus, onClick } = props
  const statusProps = {
    labelColor: colors.grey[700],
    label: subtitle
  }
  let indicatorColor
  let showIndicator

  if (indicatorStatus) {
    showIndicator = true
    indicatorColor = colors.green[500]
  } else if (indicatorStatus === false) {
    showIndicator = true
    indicatorColor = colors.grey[200]
  } else {
    showIndicator = false
  }

  let tileTags = []
  if (tags) {
    tags.forEach(function (tag, index) {
      tileTags.push(<span key={`__tile_tag_${index}`} className='Tile2-tag' color={tag.type}>{tag.text}</span>)
    })
  }

  // use ReactRouter's `to=` on local links to avoid full refreshes
  const href = rel === 'external' ? { href: props.href } : { to: props.href }
  return (
    <li className='Tile2' data-inactive={indicatorStatus === false} onClick={onClick}>
      <Link className='Tile2-link' {...href} rel={rel} target={target}>
        <div className='Tile2-tags'>
          {tileTags}
        </div>
        <div className='Tile2-inner'>
          <div className='Tile2-icon'>
            <img className='Tile2-logo' src={logo} />
          </div>
          <div className='Tile2-group'>
            <div className='Tile2-title' data-small={title.length > 20}>{title}</div>
            <div className='Tile2-subtitle'>
              <Status
                shouldAnimate={indicatorStatus}
                indicatorColor={indicatorColor}
                showIndicator={showIndicator}
                {...statusProps} />
            </div>
            {action ? <div className='Tile2-action'>{action}</div> : null}
          </div>
        </div>
      </Link>
    </li>
  )
}

Tile.displayName = 'Tile'

Tile.propTypes = {
  action: PropTypes.string,
  href: PropTypes.string.isRequired,
  indicatorStatus: PropTypes.bool,
  logo: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  subtitle: PropTypes.string,
  tags: PropTypes.array,
  target: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default Tile



// WEBPACK FOOTER //
// ./ui/Tile.js